module.exports = __webpack_public_path__ + "static/img/SMH_Logo_SCHWARZ.4378290.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/SMH_Logo_SCHWARZ.jpg
// module id = 906
// module chunks = 1